import Vue from 'vue'
import SendToastMixin from '@/mixins/sendToastMixin'
import FastInsertOnInputMixin from '@/mixins/fastInsertOnInputMixin'

Vue.mixin(SendToastMixin)
Vue.mixin(FastInsertOnInputMixin)
